export default __webpack_public_path__ + "static/media/W_head-logo.033fed1d.svg";